import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";

import { useForm } from 'react-hook-form';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCircleCheck, faCircleXmark, faTrash} from "@fortawesome/free-solid-svg-icons";


const OngletModif = (props) => {
    const token = localStorage.getItem("JWT");

    const [allThings, setAllThings] = useState([]);
    const [imgUrl, setImgUrl] = useState("");
    const [ongletSwitch, setOngletSwitch] = useState(0);           // Gestion Du menu Ajouter
    const [pageStatus, setPageStatus] = useState(0);           // Gestion de l'affichage des formulaires


    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm(    // declaration du formulaire et des fonctions nécessaire
        {
            defaultValues: {
                // media
                hashtag: "",
                nom: "",
                prix: "",
                description: "",
                rarete: "",
                disponible: "",
                aquisition: "",

                //membres
                pseudoFCU: "",
                PP: "",
                warbond: "",
                UEC: "",
                memberRsiLien: "",
                memberRsiHandle: "",
                memberRsiId: "",
            }
        }
    );

    const searchBar = (e) => {      //barre de recherche
        let search = e.target.value;
        search = search.toUpperCase();
        let x = document.getElementsByClassName('liste');

        for (const list of x) {
            let listTitle = list.firstChild
            listTitle = listTitle.textContent

            if (!listTitle.toUpperCase().includes(search)) {
                list.style.display = "none";
            }
            else {
                list.style.display = "flex";
            }
        }
    }

    function navigation(e) {       // gestion du menu


        switch (e.target.innerText) {
            case "Cartes":
                setOngletSwitch(2)
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/allCartes`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setAllThings(res.data);
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;

            case "Avatar":
                setOngletSwitch(3)
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/allAvatars`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }

                })
                    .then((res) => {
                        setAllThings(res.data);
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;

            case "Cadres":
                setOngletSwitch(4)
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/allcadres`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }

                })
                    .then((res) => {
                        setAllThings(res.data);
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;

            default:
        }
    }

    function displayOneThings(e) {          // recupère l'objet au clic 

        let focusId = e.target.id
        localStorage.setItem("focusId", focusId)
        setPageStatus(1)

        switch (ongletSwitch) {
            case 2:
                let carteId = e.target.id
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/carte/${carteId}`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setValue('hashtag', res.data.hashtag);
                        setValue('nom', res.data.nom);
                        setValue('prix', res.data.prix);
                        setValue('description', res.data.description);
                        setValue('rarete', res.data.rareté);
                        setValue('disponible', res.data.disponible);
                        setValue('aquisition', res.data.aquisition);
                        setImgUrl(res.data.lien);
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;

            case 3:
                let avatarId = e.target.id
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/avatar/${avatarId}`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setValue('hashtag', res.data.hashtag);
                        setValue('nom', res.data.nom);
                        setValue('prix', res.data.prix);
                        setValue('description', res.data.description);
                        setValue('rarete', res.data.rareté);
                        setValue('disponible', res.data.disponible);
                        setValue('aquisition', res.data.aquisition);
                        setImgUrl(res.data.lien)
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;

            case 4:
                let cadreId = e.target.id
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/cadre/${cadreId}`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setValue('hashtag', res.data.hashtag);
                        setValue('nom', res.data.nom);
                        setValue('prix', res.data.prix);
                        setValue('description', res.data.description);
                        setValue('rarete', res.data.rareté);
                        setValue('disponible', res.data.disponible);
                        setValue('aquisition', res.data.aquisition);
                        setImgUrl(res.data.lien)
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                break;

            default:
                break;
        }


    }

    const modify = data => {                //modifier un objet
        let thingId = localStorage.getItem("focusId")

        let hashtag = data.hashtag
        let nom = data.nom
        let prix = data.prix
        let description = data.description
        let rarete = data.rarete
        let disponible = data.disponible
        let aquisition = data.aquisition

        // console.log(hashtag);
        // console.log(nom);
        // console.log(prix);
        // console.log(description);
        // console.log(rarete);
        // console.log(disponible);
        // console.log(aquisition);

        switch (ongletSwitch) {
            case 2:
                axios({
                    method: "put",
                    url: `${process.env.REACT_APP_API_URL}api/modifyCarte/${thingId}`,
                    data: {
                        hashtag,
                        nom,
                        prix,
                        description,
                        rarete,
                        disponible,
                        aquisition,
                    },
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    },

                })
                    .then((res) => {
                        toast.success("Carte modifié!");
                        axios({
                            method: "get",
                            url: `${process.env.REACT_APP_API_URL}api/allcartes`,
                            headers: {
                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                            },

                        })
                            .then((res) => {
                                setAllThings(res.data);
                            })
                            .catch((err) => {
                                console.log(err);
                            })

                    })
                    .catch((err) => {
                        console.log(err);
                        toast.error("Erreur lors de la modification de la carte!");
                    })
                break;

            case 3:
                axios({
                    method: "put",
                    url: `${process.env.REACT_APP_API_URL}api/modifyAvatar/${thingId}`,
                    data: {
                        hashtag,
                        nom,
                        prix,
                        description,
                        rarete,
                        disponible,
                        aquisition,
                    },
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    },

                })
                    .then((res) => {
                        toast.success("Avatar modifié!");
                        axios({
                            method: "get",
                            url: `${process.env.REACT_APP_API_URL}api/allAvatars`,
                            headers: {
                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                            },

                        })
                            .then((res) => {
                                setAllThings(res.data);
                            })
                            .catch((err) => {
                                console.log(err);
                            })

                    })
                    .catch((err) => {
                        console.log(err);
                        toast.error("Erreur lors de la modification de l'avatar!");
                    })
                break;

            case 4:
                axios({
                    method: "put",
                    url: `${process.env.REACT_APP_API_URL}api/modifyCadre/${thingId}`,
                    data: {
                        hashtag,
                        nom,
                        prix,
                        description,
                        rarete,
                        disponible,
                        aquisition,
                    },
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    },

                })
                    .then((res) => {
                        toast.success("Cadre modifié!");
                        axios({
                            method: "get",
                            url: `${process.env.REACT_APP_API_URL}api/allCadres`,
                            headers: {
                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                            },

                        })
                            .then((res) => {
                                setAllThings(res.data);
                            })
                            .catch((err) => {
                                console.log(err);
                            })

                    })
                    .catch((err) => {
                        console.log(err);
                        toast.error("Erreur lors de la modification du cadre!");
                    })


                break;

            default:
                break;
        }

    }

    function deleteThings(e) {      //supprimer un objet
        e.preventDefault();
        let thingId = localStorage.getItem("focusId")

        confirmAlert({
            title: "Supprimer cette donnée ?",
            message: "Etes vous sûr?",
            buttons: [
                {
                    label: "Oui",
                    onClick: () => {
                        switch (ongletSwitch) {
                            case 2:
                                axios({
                                    method: "delete",
                                    url: `${process.env.REACT_APP_API_URL}api/deleteCarte/${thingId}`,
                                    headers: {
                                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                    }

                                })
                                    .then((res) => {
                                        setPageStatus(0)
                                        toast.success("Carte supprimé!");
                                        axios({
                                            method: "get",
                                            url: `${process.env.REACT_APP_API_URL}api/allcartes`,
                                            headers: {
                                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                            }

                                        })
                                            .then((res) => {
                                                setAllThings(res.data);
                                            })
                                            .catch((err) => {
                                                console.log(err);
                                            })
                                    })
                                    .catch((err) => {
                                        toast.success("Erreur de suppression!");
                                        console.log(err);
                                    })
                                break;

                            case 3:
                                axios({
                                    method: "delete",
                                    url: `${process.env.REACT_APP_API_URL}api/deleteAvatar/${thingId}`,
                                    headers: {
                                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                    }

                                })
                                    .then((res) => {
                                        setPageStatus(0)
                                        toast.success("Avatar supprimé!");
                                        axios({
                                            method: "get",
                                            url: `${process.env.REACT_APP_API_URL}api/allAvatars`,
                                            headers: {
                                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                            }

                                        })
                                            .then((res) => {
                                                setAllThings(res.data);
                                            })
                                            .catch((err) => {
                                                console.log(err);
                                            })
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                        toast.success("Erreur de suppression!");
                                    })

                                break;

                            case 4:
                                axios({
                                    method: "delete",
                                    url: `${process.env.REACT_APP_API_URL}api/deleteCadre/${thingId}`,
                                    headers: {
                                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                    }

                                })
                                    .then((res) => {
                                        setPageStatus(0)
                                        toast.success("Cadre supprimé!");
                                        axios({
                                            method: "get",
                                            url: `${process.env.REACT_APP_API_URL}api/allcadres`,
                                            headers: {
                                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                            }

                                        })
                                            .then((res) => {
                                                setAllThings(res.data);
                                            })
                                            .catch((err) => {
                                                console.log(err);
                                            })
                                    })
                                    .catch((err) => {
                                        toast.success("Erreur de suppression!");
                                        console.log(err);
                                    })

                                break;

                            default:
                                break;
                        }
                    },
                },
                {
                    label: "Non",
                    onClick: () => {

                    },
                },
            ],
        });


    }

    useEffect(() => {
    }, []);

    return (

        <div className='galeriePage'>

            <Link className='exitButton' to="/profil"><FontAwesomeIcon icon={faArrowLeft} /></Link>

            <ToastContainer
                position="bottom-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="dark"
            />

            <div className='galeriePage__container'>

                <div className='galeriePage__container__list'>

                    <div className='galeriePage__container__list__menu'>
                        <button id='cartes' onClick={navigation}>Cartes</button>
                        <button id='avatars' onClick={navigation}>Avatar</button>
                        <button id='cadres' onClick={navigation}>Cadres</button>
                    </div>

                    <div className='galeriePage__container__list__searchBarContainer'>
                        <label htmlFor="searchBar">Rechercher:</label>
                        <input className='galeriePage__container__list__searchBarContainer__searchBar' type="text" id="searchBar" name="searchBar" onChange={searchBar} />
                    </div >

                    <div className='galeriePage__container__list__things'>
                        {allThings.map(things => (
                            <div className='liste' key={things.id} id={things.id} onClick={displayOneThings} >
                                {things.nom}
                                {things.disponible ? <FontAwesomeIcon className='galerieIconCheck' icon={faCircleCheck} /> : <FontAwesomeIcon className='galerieIconXmark' icon={faCircleXmark} />}
                            </div>
                        ))}
                    </div>

                </div>

                <div className='galeriePage__container__content'>
                    {pageStatus === 0 &&
                        <div className='ongletModif__container__content__welcomeMessage'>
                            <h2>Ajoutez ou modifiez les assets de la boutiques</h2>
                        </div>
                    }
                    {pageStatus > 0 &&

                        <form onSubmit={handleSubmit(modify)} >

                            <div className='galerieTopCont'>

                                <span>
                                    <label htmlFor="nom">Nom:</label>
                                    <input className='textInputModif ' type="text" id="nom" name="nom"  {...register("nom")} required />
                                </span>

                                <span>
                                    <label htmlFor="hashtag">Hashtag:</label>
                                    <input className='textInputModif' type="text" id="hashtag" name="hashtag" {...register("hashtag")} />
                                </span>

                                <span>
                                    <label htmlFor="prix">Prix:</label>
                                    <input className='textInputModif' type="number" id="prix" name="prix"  {...register("prix")} required />
                                </span>

                                <span>
                                    <label htmlFor="disponible">Disponible dans la boutique?</label>
                                    <input type="checkbox" id="disponible" name="disponible"  {...register("disponible")} />
                                </span>

                            </div>

                            <div className='galerieBotCont'>

                                <div className='galerieImageCont' >
                                    <img src={imgUrl} alt='Média selectionné' />
                                </div>

                                <div className='galerieInfoCont'>
                                    <span >
                                        <fieldset>
                                            <legend>Aquisition:</legend>
                                            <div>
                                                <input type="radio" id="Boutique" name="aquisition" value="Boutique" {...register("aquisition")} required />
                                                <label htmlFor="Boutique">Boutique</label>
                                            </div>

                                            <div>
                                                <input type="radio" id="Event" name="aquisition" value="Event" {...register("aquisition")} />
                                                <label htmlFor="Event">Event</label>
                                            </div>

                                            <div>
                                                <input type="radio" id="Tournoi" name="aquisition" value="Tournoi" {...register("aquisition")} />
                                                <label htmlFor="Tournoi">Tournoi</label>
                                            </div>

                                            <div>
                                                <input type="radio" id="Gratuit" name="aquisition" value="Gratuit" {...register("aquisition")} />
                                                <label htmlFor="Gratuit">Gratuit</label>
                                            </div>
                                        </fieldset>
                                    </span>

                                    <span>
                                        <fieldset>
                                            <legend>Rareté:</legend>
                                            <div>
                                                <input type="radio" id="Commune" name="rarete" value="Commune" {...register("rarete")} required />
                                                <label htmlFor="Commune">Commune</label>
                                            </div>

                                            <div>
                                                <input type="radio" id="Rare" name="rarete" value="Rare" {...register("rarete")} />
                                                <label htmlFor="Rare">Rare</label>
                                            </div>

                                            <div>
                                                <input type="radio" id="Epic" name="rarete" value="Epic" {...register("rarete")} />
                                                <label htmlFor="Epic">Epic</label>
                                            </div>

                                            <div>
                                                <input type="radio" id="Légendaire" name="rarete" value="Légendaire" {...register("rarete")} />
                                                <label htmlFor="Légendaire">Légendaire</label>
                                            </div>
                                        </fieldset>
                                    </span>

                                    <div className='galerieModifCont'>
                                        <label htmlFor="description">Description:</label>
                                        <input className='descriptionInputModif' type="text" id="description" name="description" {...register("description")} required />
                                    </div>

                                </div>




                            </div>

                            <div className='galerieButtonCont' >
                                {/* <button className='validateButtonDelete' onClick={deleteThings} value="supprimer" /> */}
                                <input className='validateButtonModif' type="submit" value="Modifier" />
                                <button  className='validateButtonDelete' onClick={deleteThings} value="supprimer"><FontAwesomeIcon icon={faTrash} /></button>
                            </div>

                        </form>

                    }


                </div>

            </div>
        </div>
    );
};

export default OngletModif;